// extracted by mini-css-extract-plugin
module.exports = {"rate":"UserContractPage-styles-module--rate--3eZ4V","grade":"UserContractPage-styles-module--grade--3AtCp"};